/**
 * Canonical copy of the ZHELTA Systems catalog, synced from the backend via
 * GET /api/systems/services on mount. This file only holds the ORDER of slugs
 * and static UI copy — prices are always fetched fresh from the backend.
 */
export const SYSTEMS_SLUG_ORDER = [
  'managed-it-services',
  'it-systems-management',
  'it-help-desk-remote-support',
  'cloud-infrastructure-support',
  'cybersecurity-support',
  'it-infrastructure-deployment',
  'network-infrastructure-management',
  'backup-data-protection',
  'surveillance-system-deployment',
  'website-development',
  'application-development',
  'it-consulting-technology-advisory',
];

// External Plutio scheduler — single source of truth so all demo / consultation
// CTAs route to the same live calendar.
export const PLUTIO_SCHEDULER_URL = 'https://portal.zhelta.com/p/scheduler/KfMLXSkC6pkS4utFn';

// Map a service's cta_type to user-facing labels and booking page context.
export function getCtaCopy(service) {
  const isConsult = service?.cta_type === 'consultation';
  return {
    isConsultation: isConsult,
    bookLabel: isConsult ? 'Book a Consultation' : 'Book a Demo',
    bookLabelShort: isConsult ? 'Consultation' : 'Demo',
    bookCtaUpper: isConsult ? 'BOOK A CONSULTATION' : 'BOOK A DEMO',
    headerEyebrow: isConsult ? 'Consultation' : 'Book a Demo',
    heroTitle: isConsult ? 'Get expert\u00A0consultation.' : 'in action.',
    heroSubtitle: isConsult
      ? 'Let our technology specialists help you plan, scope, and price your project with confidence.'
      : 'Let our technology specialists show you how ZHELTA Systems helps individuals and businesses manage devices, infrastructure, and cybersecurity with confidence.',
  };
}

export function formatTierPrice(tier, service) {
  const unit = service?.unit || '';
  const n = Math.round(tier.price);
  const suffix = unit ? `/${unit.replace('starting', '').trim() || 'starting'}` : '';
  const startingLabel = unit === 'starting' ? ' starting' : '';
  if (unit === 'starting') return `$${n.toLocaleString()}${startingLabel}`;
  return `$${n.toLocaleString()}${suffix}`;
}
